import {createAction, handleActions} from 'redux-actions';
import {takeLatest} from 'redux-saga/effects';

import createRequestSaga, {createRequestActionTypes} from '../../api/createRequestSaga';
import * as databaseAPI from '../../api/admin/database';

// 액션 타입
const INITIALIZE = 'database/INITIALIZE';

const CHANGE_FIELD = 'database/CHANGE_FIELD';

const [READ_DATABASE_LIST, READ_DATABASE_LIST_SUCCESS, READ_DATABASE_LIST_FAILURE] = createRequestActionTypes('database/READ_DATABASE_LIST');

const [CONNECT_ORIGINAL_DB, CONNECT_ORIGINAL_DB_SUCCESS, CONNECT_ORIGINAL_DB_FAILURE] = createRequestActionTypes('database/CONNECT_ORIGINAL_DB');

const [CONNECT_NEW_DB, CONNECT_NEW_DB_SUCCESS, CONNECT_NEW_DB_FAILURE] = createRequestActionTypes('database/CONNECT_NEW_DB');

const [CONNECT_NEW_SQLITE, CONNECT_NEW_SQLITE_SUCCESS, CONNECT_NEW_SQLITE_FAILURE] = createRequestActionTypes('database/CONNECT_NEW_SQLITE');

const [SAVE_DB, SAVE_DB_SUCCESS, SAVE_DB_FAILURE] = createRequestActionTypes('database/SAVE_DB');

const [SAVE_SQLITE, SAVE_SQLITE_SUCCESS, SAVE_SQLITE_FAILURE] = createRequestActionTypes('database/SAVE_SQLITE');

const [UPDATE_DB, UPDATE_DB_SUCCESS, UPDATE_DB_FAILURE] = createRequestActionTypes('database/UPDATE_DB');

const [UPDATE_SQLITE, UPDATE_SQLITE_SUCCESS, UPDATE_SQLITE_FAILURE] = createRequestActionTypes('database/UPDATE_SQLITE');

const [DELETE_DB, DELETE_DB_SUCCESS, DELETE_DB_FAILURE] = createRequestActionTypes('database/DELETE_DB');

const [CHANGE_ORDER, CHANGE_ORDER_SUCCESS, CHANGE_ORDER_FAILURE] = createRequestActionTypes('database/CHANGE_ORDER');

const [CANCEL_CONNECT, CANCEL_CONNECT_SUCCESS, CANCEL_CONNECT_FAILURE] = createRequestActionTypes('database/CANCEL_CONNECT');

// 액션 생성 함수
export const initialize = createAction(INITIALIZE);

export const changeField = createAction(
    CHANGE_FIELD,
    ({ name, value }) => ({ name, value })
);

export const readDatabaseList = createAction(
    READ_DATABASE_LIST,
    ({ aliasName, dbType, viewType, page }) => ({ aliasName, dbType, viewType, page })
);

export const connectOriginalDB = createAction(
    CONNECT_ORIGINAL_DB,
    ({ id }) => ({ id })
);

export const connectNewDB = createAction(
    CONNECT_NEW_DB,
    ({ dbType, dbName, hostName, portNumber, accessId, password, aliasName }) => ({ dbType, dbName, hostName, portNumber, accessId, password, aliasName })
);

export const connectNewSQLite = createAction(
    CONNECT_NEW_SQLITE,
    (formData) => (formData)
);

export const saveDB = createAction(
    SAVE_DB,
    ({ dbType, dbName, hostName, portNumber, accessId, password, aliasName }) => ({ dbType, dbName, hostName, portNumber, accessId, password, aliasName })
);

export const saveSQLite = createAction(
    SAVE_SQLITE,
    (formData) => (formData)
);

export const updateDB = createAction(
    UPDATE_DB,
    ({ id, dbType, dbName, hostName, portNumber, accessId, password, aliasName }) => ({ id, dbType, dbName, hostName, portNumber, accessId, password, aliasName })
);

export const updateSQLite = createAction(
    UPDATE_SQLITE,
    ({ id, formData }) => ({ id, formData })
);

export const deleteDB = createAction(
    DELETE_DB,
    ({ id }) => ({ id })
);

export const changeOrder = createAction(
    CHANGE_ORDER,
    ({ id, targetOrder }) => ({ id, targetOrder })
);

export const cancelConnect = createAction(
    CANCEL_CONNECT,
    ({ dbType, dbName, hostName, portNumber, accessId, password, dbFile, aliasName }) => ({ dbType, dbName, hostName, portNumber, accessId, password, dbFile, aliasName })
);

// 사가 타입
const readDatabaseListSaga = createRequestSaga(READ_DATABASE_LIST, databaseAPI.readDatabaseList);
const connectOriginalDBSaga = createRequestSaga(CONNECT_ORIGINAL_DB, databaseAPI.connectOriginalDB);
const connectNewDBSaga = createRequestSaga(CONNECT_NEW_DB, databaseAPI.connectNewDB);
const connectNewSQLiteSaga = createRequestSaga(CONNECT_NEW_SQLITE, databaseAPI.connectNewSQLite);
const saveDBSaga = createRequestSaga(SAVE_DB, databaseAPI.saveDB);
const saveSQLiteSaga = createRequestSaga(SAVE_SQLITE, databaseAPI.saveSQLite);
const updateDBSaga = createRequestSaga(UPDATE_DB, databaseAPI.updateDB);
const updateSQLiteSaga = createRequestSaga(UPDATE_SQLITE, databaseAPI.updateSQLite);
const deleteDBSaga = createRequestSaga(DELETE_DB, databaseAPI.deleteDB);
const changeOrderSaga = createRequestSaga(CHANGE_ORDER, databaseAPI.changeOrder);
const cancelConnectSaga = createRequestSaga(CANCEL_CONNECT, databaseAPI.cancelConnect);

// 사가 함수
export function* databaseSaga() {
    yield takeLatest(READ_DATABASE_LIST, readDatabaseListSaga);
    yield takeLatest(CONNECT_ORIGINAL_DB, connectOriginalDBSaga);
    yield takeLatest(CONNECT_NEW_DB, connectNewDBSaga);
    yield takeLatest(CONNECT_NEW_SQLITE, connectNewSQLiteSaga);
    yield takeLatest(SAVE_DB, saveDBSaga);
    yield takeLatest(SAVE_SQLITE, saveSQLiteSaga);
    yield takeLatest(UPDATE_DB, updateDBSaga);
    yield takeLatest(UPDATE_SQLITE, updateSQLiteSaga);
    yield takeLatest(DELETE_DB, deleteDBSaga);
    yield takeLatest(CHANGE_ORDER, changeOrderSaga);
    yield takeLatest(CANCEL_CONNECT, cancelConnectSaga);
}

const initialState = {
    aliasName: null,
    dbType: null,
    viewType: 'LIST',
    page: 1,
    pagination: null,
    listResponse: null,
    listError: null,
    connectOriginalResponse: null,
    connectOriginalError: null,
    connectNewResponse: null,
    connectNewError: null,
    saveResponse: null,
    saveError: null,
    updateResponse: null,
    updateError: null,
    deleteResponse: null,
    deleteError: null,
    changeResponse: null,
    changeError: null,
    cancelResponse: null,
    cancelError: null
};

const database = handleActions(
    {
        [INITIALIZE]: () => initialState,
        [CHANGE_FIELD]: (state, { payload: { name, value }} ) => ({
            ...state,
            [name]: value
        }),
        [READ_DATABASE_LIST_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            listResponse: response,
            listError: null,
            pagination: response.data.pagination
        }),
        [READ_DATABASE_LIST_FAILURE]: (state, { payload: error }) => ({
            ...state,
            listResponse: null,
            listError: error.response.data
        }),
        [CONNECT_ORIGINAL_DB_SUCCESS]: (state, { payload: response }) => {
            const { id, state: newState } = response.data;
            
            const updatedListResponse = state.listResponse ? {
                ...state.listResponse,
                data: {
                    ...state.listResponse.data,
                    data: state.listResponse.data.data.map(item => 
                        item.id === id ? { ...item, state: newState } : item
                    )
                }
            } : null;

            return {
                ...state,
                listResponse: updatedListResponse,
                connectOriginalResponse: response.data,
                connectOriginalError: null
            };
        },
        [CONNECT_ORIGINAL_DB_FAILURE]: (state, { payload: error }) => ({
            ...state,
            connectOriginalResponse: null,
            connectOriginalError: error.response.data
        }),
        [CONNECT_NEW_DB_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            connectNewResponse: response,
            connectNewError: null
        }),
        [CONNECT_NEW_DB_FAILURE]: (state, { payload: error }) => ({
            ...state,
            connectNewResponse: null,
            connectNewError: error.response.data
        }),
        [CONNECT_NEW_SQLITE_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            connectNewResponse: response,
            connectNewError: null
        }),
        [CONNECT_NEW_SQLITE_FAILURE]: (state, { payload: error }) => ({
            ...state,
            connectNewResponse: null,
            connectNewError: error.response.data
        }),
        [SAVE_DB_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            saveResponse: response,
            saveError: null
        }),
        [SAVE_DB_FAILURE]: (state, { payload: error }) => ({
            ...state,
            saveResponse: null,
            saveError: error.response.data
        }),
        [SAVE_SQLITE_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            saveResponse: response,
            saveError: null
        }),
        [SAVE_SQLITE_FAILURE]: (state, { payload: error }) => ({
            ...state,
            saveResponse: null,
            saveError: error.response.data
        }),
        [UPDATE_DB_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            updateResponse: response.data,
            updateError: null
        }),
        [UPDATE_DB_FAILURE]: (state, { payload: error }) => ({
            ...state,
            updateResponse: null,
            updateError: error.response.data
        }),
        [UPDATE_SQLITE_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            updateResponse: response.data,
            updateError: null
        }),
        [UPDATE_SQLITE_FAILURE]: (state, { payload: error }) => ({
            ...state,
            updateResponse: null,
            updateError: error.response.data
        }),
        [DELETE_DB_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            deleteResponse: response,
            deleteError: null
        }),
        [DELETE_DB_FAILURE]: (state, { payload: error }) => ({
            ...state,
            deleteResponse: null,
            deleteError: error.response.data
        }),
        [CHANGE_ORDER_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            changeResponse: response,
            changeError: null
        }),
        [CHANGE_ORDER_FAILURE]: (state, { payload: error }) => ({
            ...state,
            changeResponse: null,
            changeError: error.response.data
        }),
        [CANCEL_CONNECT_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            cancelConnect: response.data,
            cancelError: null
        }),
        [CANCEL_CONNECT_FAILURE]: (state, { payload: error }) => ({
            ...state,
            cancelConnect: null,
            cancelError: error.response.data
        })
    },
    initialState
);

export default database;
